import PropTypes from "prop-types";

/**
 * @typedef {Object} ReferrersCommunityProps
 * @property {string|null} [whatsappCommunityUrl]
 */

export const REFERRERS_COMMUNITY_PROPS = {
  whatsappCommunityUrl: PropTypes.string,
};
